import type { CMYKColor } from "../types/colors/CMYKColor"
import type { RGBColor } from "../types/colors/RGBColor"
import type { ColorComponent } from "../types/Units"

/**
 * Converts CMYK color to RGB color
 * Assumes CMYK values are in range 0-1
 */
export const CmykToRgb = ({
  alpha,
  cyan,
  black,
  magenta,
  yellow,
}: CMYKColor): RGBColor => ({
  alpha,
  blue: ((1 - yellow) * (1 - black)) as ColorComponent,
  green: ((1 - magenta) * (1 - black)) as ColorComponent,
  red: ((1 - cyan) * (1 - black)) as ColorComponent,
})
